import React, { useRef, useEffect, useState } from "react";
import "./employeeDetails.css";
import strings from "../../utils/property-file/Employeedetails.json";
import Ripple from "../button/ripple";
import Employee from "../employeeComponent/employee";
import api from "../../services/api";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import moment from "moment";
import SpinnerButton from "../button/spinnerButton";
import constants from "../../utils/constants";
import debounce from "../../utils/commonFunction/debounce";
import EmployeeAttendanceReportPopUp from "./employeeAttendanceReportExport/employeeAttendanceReportPopUp";
import closeIcon from "../../Asset/Images/close-for-logout.svg"
import SpinnerButtonMedium from "../button/SpinnerButtonMedium";
import PropTypes from "prop-types"
import SynchronizeUsers from "./synchroniseUsers/synchroniseUsers";
import SynchroniseConfirmationModal from "./synchroniseUsers/synchroniseUserConformation";


export default function EmployeeDetails() {
  const [employeeStatus, setEmployeeStatus] = useState([]);
  const [showActiveEmployee, setShowActiveEmployee] = useState(true);
  const [showResignedEmployee, setShowResignedEmployee] = useState(false);
  const [modalAddEmployee, setModalAddEmployee] = useState(false);
  const [messageEmp, setMessageEmp] = useState("");
  const [isLoadingEmployee, setIsLoadingEmployee] = useState(true);
  const [openSearchBar, setOpenSearchBar] = useState(false)
  const [employeeSearchKey, setEmployeeSearchKey] = useState("")
  const debounceOnChange = React.useCallback(debounce(handleEmpLoyeeSearch, 400), []);
  const [exportModalShow, setExportModalShow] = useState(false);
  const [isBluewingsCustomer, setIsBluewingsCustomer] = useState(false);
  const [synchroniseUsers, setSynchroniseUsers] = useState([]);
  const [isSynchronise, setIsSynchronise] = useState(false);
   const [isSynchroniseDatabuttonDisable, setIsSynchroniseDatabuttonDisable] = useState(false);
  const [isSynchroniseConformation, setIsSynchroniseConformation] = useState(false);
  const [finalSynchroniseUsers, setFinalSynchroniseUsers] = useState([]);
  function handleEmpLoyeeSearch(value) {
    setEmployeeSearchKey(value.trim());
  }

  const getEmployeeStatus = async (employeeSearchKey) => {
    setIsLoadingEmployee(true);
    try {
      let obj = {
        name: employeeSearchKey ? employeeSearchKey : ""
      }
      const response = await api.getEmployeeStatus(obj.name);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmployeeStatus(data.body);
          setIsSynchroniseDatabuttonDisable(false)
        }
        else {
          setEmployeeStatus(null)
          setMessageEmp(data.body)
        }
        setMessageEmp(data ? data.body ? data.body : strings.errorMessage : strings.errorMessage);
      } else {
        setEmployeeStatus(null);
      }
      setIsLoadingEmployee(false);
    } catch (error) {
       setIsSynchroniseDatabuttonDisable(false)
      setEmployeeStatus(null);
      setIsLoadingEmployee(false);
    }
  };

  useEffect(() => {
    getEmployeeStatus();
    setIsBluewingsCustomer(JSON.parse(localStorage.getItem('isBluewingsCustomer')))
  }, []);

  function inactiveEmp() {
    setShowActiveEmployee(false);
    setShowResignedEmployee(true);
  }

  const ref = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isMenuOpen]);

  useEffect(() => {
    if (employeeSearchKey.length >= 3) {
      getEmployeeStatus(employeeSearchKey);
    }
    else if (employeeSearchKey.length === 0) {
      getEmployeeStatus("");
    }
  }, [employeeSearchKey])


  const getSynchroniseData = async () => {
    try {
      setIsSynchronise(true)
      setIsLoadingEmployee(true);
      const response = await api.synchroniseEmployeeData();
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          console.log("setSynchroniseUsers::", data.body);
          setSynchroniseUsers(data.body)
          setIsLoadingEmployee(false);
        } else {
          setSynchroniseUsers([])
          setIsLoadingEmployee(false);
        }
      }
      console.log("setSynchroniseUsers::", synchroniseUsers);

    } catch (error) {
      setIsLoadingEmployee(false);
    }
  }

  const handleBack = () => {
    setIsSynchronise(false);
  }

  const handelSynchroniseUser = (data) => {
    if (data.length === 0) {
      toast.error('Please select at least one user');
      setFinalSynchroniseUsers([]);
      return;
    }
    const hasAdminSelected = data.some(
      user => user.type === 'admin' && user.isActive === 1
    );
    if (!hasAdminSelected) {
      toast.error(strings.adminErrorMsg);
      setFinalSynchroniseUsers([]);
      return;
    }
    setFinalSynchroniseUsers(data);
    setIsSynchroniseConformation(true);
  };

  const importOrUpdateSynchroniseUsers = async () => {
    try {
      setIsSynchroniseConformation(false);
      setIsSynchronise(false);
      setIsSynchroniseDatabuttonDisable(true);
      setIsLoadingEmployee(true);
      const body = {
        userList: finalSynchroniseUsers
      }
      const response = await api.importOrUpdateSynchroniseUsers(body)
      if (response && response.data) {
        const data = JSON.parse(response.data);
        setIsSynchroniseConformation(false);
        setFinalSynchroniseUsers([]);
        setIsLoadingEmployee(false);
        if (response.success) {
          toast.success(data.body, 'success');
          getEmployeeStatus();
        } else {
          setIsSynchroniseDatabuttonDisable(false)
          setSynchroniseUsers([]);
          toast.error(data.body, 'error');
        }
      }
    } catch (error) {
      setIsLoadingEmployee(false);
      setIsSynchroniseDatabuttonDisable(false);
      setIsSynchroniseConformation(false);
    }
  }

  const handleSynchroniseConformationCancel = () => {
    setIsSynchroniseConformation(false)
  }
  const handleSynchroniseConformationConfirm = () => {
    importOrUpdateSynchroniseUsers()
  }
  console.log("employeeStatus",employeeStatus);
  

  return (
    <>
      <SynchroniseConfirmationModal
        isSynchronise={isSynchroniseConformation}
        handleCancel={handleSynchroniseConformationCancel}
        handleConfirm={handleSynchroniseConformationConfirm}
      />
      <div className="emp-detail-main-container">
        <div className="emp-detail-sub-container mt-3">
          <div ref={ref}>
            <div className={isSynchronise ? "" : "emp-details-header"}>
              {!openSearchBar ? <div className="d-flex justify-content-between align-items-center">
                <div className={isSynchronise ? "emp-profile synchronise" : "emp-profile"} >
                  {isSynchronise ? <div class="syncronise-data">
                    <div class="back-button">
                      <i class="ri-arrow-left-line" onClick={handleBack}></i>
                      Syncronize users
                    </div>

                  </div>
                    : strings.employee_profile}
                  <div
                    className="responsive-menu"
                    onClick={() => setIsMenuOpen((oldState) => !oldState)}
                  >
                    <i className="ri-more-2-fill"></i>
                  </div>
                  {isMenuOpen && (
                    <div
                      className={
                        isMenuOpen
                          ? "emp-det-drop-down"
                          : "emp-det-drop-down-hide"
                      }
                    >
                      <div>
                        <button onClick={(() => {
                          setExportModalShow(true)
                        })}>{strings.export_rep}</button>
                      </div>
                      <div>

                        {isBluewingsCustomer ?
                          <button
                            type="button"
                            className="emp-det-add-emp-responsive"
                            onClick={() => getSynchroniseData()}
                          >
                            {strings.synchroniseData}
                            <Ripple duration={1000} />

                          </button>
                          : <button
                            type="button"
                            className="emp-det-add-emp-responsivey"
                            onClick={() => setModalAddEmployee(true)}
                          >
                            <i className="ri-add-line emp-add-icon"></i>
                            {strings.add_emp}
                            <Ripple duration={1000} />
                          </button>}
                      </div>
                    </div>
                  )}
                </div>
                {!isSynchronise && (<div className="d-flex align-items-center text-white">
                  <div className="open-employee-search-container me-3"
                    onClick={() => {
                      setOpenSearchBar(true)
                    }}
                  >
                    <i className="ri-user-search-line open-employee-search-icon"></i>
                  </div>

                  <div className="emp-prof-exp me-3">
                    <button type="button" onClick={(() => setExportModalShow(true))} className="btn exp-btn btn-secondary">
                      {strings.export_rep}
                      <Ripple duration={1000} />
                    </button>
                  </div>
                  <div className="emp-prof-btn">
                    {isBluewingsCustomer ?
                      <button
                        type="button"
                        className="btn add-emp-btn btn-secondary"
                        onClick={() => getSynchroniseData()}
                        disabled= {isSynchroniseDatabuttonDisable}
                      >
                        {strings.synchroniseData}
                        <Ripple duration={1000} />
                      </button>
                      : <button
                        type="button"
                        className="btn add-emp-btn btn-secondary"
                        onClick={() => setModalAddEmployee(true)}
                      >
                        <i className="ri-add-line emp-add-icon"></i>
                        {strings.add_emp}
                        <Ripple duration={1000} />
                      </button>}

                  </div>
                  <AddEmployeeModal
                    show={modalAddEmployee}
                    employeeStatusApi={getEmployeeStatus}
                    onHide={() => setModalAddEmployee(false)}
                  />
                </div>)}


              </div> : <div className="search-bar-employee">
                <input
                  className="search-emp"
                  type="text"
                  placeholder={strings.searchInputPlaceholder}
                  onChange={(e) => {
                    debounceOnChange(e.target.value)
                  }}
                />

                <i className="ri-close-line close-icon" onClick={() => {
                  setEmployeeSearchKey('')
                  getEmployeeStatus()
                  setOpenSearchBar(false)
                }}></i>
              </div>}
              {!isSynchronise && (<div className="emp-status row mt-4 mb-3">
                <div className="col-6 active-emp">
                  <button
                    type="button"
                    className={
                      showActiveEmployee
                        ? "btn btn-secondary emp-active-btn-active-state"
                        : "btn btn-secondary emp-active-btn"
                    }
                    onClick={() => {
                      setShowActiveEmployee(true);
                      setShowResignedEmployee(false);
                    }}
                  >
                    {strings.active_emp}
                  </button>
                </div>
                <div className="col-6 inactive-emp">
                  <button
                    type="button"
                    className={
                      showResignedEmployee
                        ? "btn btn-secondary emp-active-btn-active-state"
                        : "btn btn-secondary emp-active-btn"
                    }
                    onClick={inactiveEmp}
                  >
                    {strings.inactive_emp}
                  </button>
                </div>
              </div>)}
            </div>
            {isLoadingEmployee ?
              <div className="loader-employee-status">
                <SpinnerButton />
              </div>
              :
              <div className="mt-3 emp-container text-white">
                {isSynchronise ?
                  <SynchronizeUsers synchroniseUsers={synchroniseUsers} onConfirm={handelSynchroniseUser} /> : <>
                    {showActiveEmployee ? (
                      <div className="emp-data">
                        {employeeStatus && employeeStatus.length > 0 ? (
                          employeeStatus.map((item, index) => {
                            return item.isActive === true ? (
                              <Employee key={index}
                                emp_Name={item.name}
                                empId={item._id}
                                empType={item.empType}
                                empProfilePic={item.profilePic}
                                empDesignation={item.designation}
                              />
                            ) : null;
                          })
                        ) : (
                          <p className="no-employee-message">{strings.noDataLabel}</p>
                        )}
                      </div>

                    ) : showResignedEmployee ? (
                      <div className="emp-data">
                        {employeeStatus && employeeStatus.length > 0 ? (
                          employeeStatus.map((item, index) => {
                            return item.isActive === false ? (
                              <Employee key={index}
                                emp_Name={item.name}
                                empId={item._id}
                                empType={item.empType}
                                empProfilePic={item.profilePic}
                                empDesignation={item.designation}
                              />
                            ) : null;
                          })
                        ) : (
                          <p className="no-employee-message">{strings.noDataLabel}</p>
                        )}
                      </div>
                    ) : (
                      <div className="text-center text-white w-100">{messageEmp}</div>
                    )}
                  </>}

              </div>
            }
          </div>
          {exportModalShow && (
            <EmployeeAttendanceReportPopUp
              show={exportModalShow}
              employeename={employeeStatus}
              onHide={() => setExportModalShow(false)}
            />
          )}
        </div>
      </div>
    </>
  );
}

function AddEmployeeModal(props) {
  const [addingEmployee, setAddingEmployee] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [selectedImage, setSelectedImage] = useState(null);

  const formSubmit = async (data) => {
    try {
      const newEmpEmail = data.email;
      setAddingEmployee(true);
      let body = {
        name: data.name,
        email: data.email,
        empId: data.empID,
        empType: data.empType,
        designation: data.empDes,
        department: data.empDept,
        dateOfJoining: data.joiningDate,
        location: data.empLoc,
        contact: data.empCon,
        dateOfBirth: data.empDob,
        nationality: data.empNat,
        gender: data.empGender,
        maritalStatus: data.maritalStatus,
        fathersName: data.empFather,
        physicallyChallenged: data.physicallyChallenged,
        internationalEmployee: data.internationalEmployee,
        bloodGroup: data.bloodGroup,
        employmentType: data.employmentType
      };
      const response = await api.addEmployee(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          await addProfileUpload(newEmpEmail);
          toast.success(data.body, { toastId: "error14" });
          reset();
          props.employeeStatusApi();
          props.onHide();
          setSelectedImage(null);
        } else {
          toast.error(data.body, { toastId: "error6" });
        }
        setAddingEmployee(false);
      }
      else {
        setAddingEmployee(false);
      }
    } catch (error) {
      toast.error(strings.somethingWentWrong, { toastId: "error6" });
      setAddingEmployee(false);
    }
  };

  const addProfileUpload = async (email) => {
    try {
      if (selectedImage) {
        const response = await api.addEmpProfileUpload(email, selectedImage);
        if (response.success) {
          return response;
        }
      } else {
        return false;
      }
    } catch (e) {
      return e;
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      className="add-employee-modal-container"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="employee-addition-main-container">
        <div className="employee-addition-modal-header">
          <div className="employee-add-heading">
            {strings.modalHeading}
          </div>
          <img src={closeIcon} alt="close-icon" className="close-icon-add-employee-modal" onClick={props.onHide} />
        </div>
        <div className="employee-addition-form">
          <form
            encType="multipart/form-data"
            onSubmit={handleSubmit(formSubmit)}
          >
            <div className="employee-photo-upload">
              <label htmlFor="fileToUpload" className="emp-photo-label">
                {selectedImage ? (
                  <>
                    <div className="add-profile-photo-add-employee">
                      <img
                        alt="add-icon"
                        className="add-employee-profile"
                        src={URL.createObjectURL(selectedImage)}
                      />
                    </div>
                  </>
                ) : (
                  <div className="add-profile-photo-add-employee">
                    <i className="ri-user-add-line"></i>
                  </div>
                )}
                <input
                  {...register("profilePhoto")}
                  type="file"
                  name="fileToUpload"
                  id="fileToUpload"
                  accept="image/*"
                  onChange={(event) => {
                    if (event.target.files[0]) {
                      const fileName = event.target.files[0].name;
                      let idxDot = fileName.lastIndexOf(".") + 1,
                        extFile = fileName
                          .substr(idxDot, fileName.length)
                          .toLowerCase();
                      if (
                        extFile === strings.jpgLabel ||
                        extFile === strings.jpegLabel ||
                        extFile === strings.pngLabel ||
                        extFile === strings.svgLabel ||
                        extFile === strings.bmpLabel
                      ) {
                        if (event.target.files[0].size <= 10000000) {
                          setSelectedImage(event.target.files[0]);
                        } else {
                          toast.error(strings.fileSizeError);
                          setSelectedImage(false);
                        }
                      } else {
                        toast.error(strings.fileError);
                      }
                    } else {
                      setSelectedImage(false);
                    }
                  }}
                />
              </label>
            </div>

            <div className="form-input-container add-emp-body">
              <div className="form-floating">
                <input
                  {...register("name", {
                    required: strings.nameValidation,
                    minLength: {
                      value: 2,
                      message: strings.minChar,
                    },
                    maxLength: {
                      value: 50,
                      message: strings.maxCharName,
                    },
                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceSecond,
                      message: strings.errorValid,
                    },

                  })}
                  type="text"
                  className={
                    errors.name
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.name}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.name && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.name.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("email", {
                    required: strings.emailValidation,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: strings.emailValidate,
                    },
                  })}
                  type="email"
                  className={
                    errors.email
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.emailAddress}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.email && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.email.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("empID", {
                    required: strings.empIDValidation,
                    maxLength: {
                      value: 10,
                      message: strings.empIdValidate,
                    },
                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceThird,
                      message: strings.validValue
                    },
                  })}
                  type="text"
                  className={
                    errors.empID
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empId}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empID && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empID.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <div className="mt-1 mb-1 text-light">
                  <label className="mt-1 select-box-label">
                    {strings.empType}
                  </label>
                  <select
                    {...register("empType", { required: true })}
                    className={
                      errors.empType
                        ? "bg-transparent error"
                        : "bg-transparent select-dropdown small-arrow"
                    }
                  >
                    <option id="dropdown-label" value="" hidden defaultValue={strings.selectEmpType}>
                      {strings.selectEmpType}
                    </option>
                    {constants.empList.map((item, index) => (
                      <option id="dropdown-label" value={item.label} key={index}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  <div className={"form-validation"}>
                    <small>
                      {errors.empType && (
                        <span>
                          <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong> {strings.empTypeValidation}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("empDes", {
                    required: strings.empDesValidation,
                    minLength: {
                      value: 2,
                      message: strings.minChar,
                    },
                    maxLength: {
                      value: 50,
                      message: strings.empDesignationMaxLength
                    },
                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceThird,
                      message: strings.validValue
                    },
                  })}
                  type="text"
                  className={
                    errors.empDes
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empDes}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empDes && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empDes.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("empDept", {
                    required: strings.empDeptValidation,
                    minLength: {
                      value: 2,
                      message: strings.minChar,
                    },
                    maxLength: {
                      value: 50,
                      message: strings.empDepartmentError
                    },
                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceThird,
                      message: strings.validValue
                    },
                  })}
                  type="text"
                  className={
                    errors.empDept
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empDept}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empDept && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empDept.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("joiningDate", { required: true })}
                  type="date"
                  id="joining-date"
                  className={
                    errors.joiningDate
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                  max={moment().format("YYYY-MM-DD")}
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.joinDate}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.joiningDate && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {strings.empJDValidation}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("empLoc", {
                    required: strings.empLocationValidation,
                    minLength: {
                      value: 2,
                      message: strings.minChar,
                    },
                    maxLength: {
                      value: 100,
                      message: strings.maxCharAdress,
                    },

                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceThird,
                      message: strings.validValue,
                    },
                  })}
                  type="text"
                  className={
                    errors.empLoc
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empLoc}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empLoc && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empLoc.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>

              <div className="form-floating input-gap contact-number">
                <input
                  {...register("empCon", {
                    required: strings.empContactValidation,
                    minLength: {
                      value: 10,
                      message: strings.minCharError,
                    },
                    maxLength: {
                      value: 10,
                      message: strings.minCharError,
                    },

                    pattern: {
                      value: /^[0-9]+$/,
                      message: strings.numbersOnly,
                    },
                  })}
                  type="number"
                  className={
                    errors.empCon
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empCon}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empCon && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empCon.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>

              <div className="form-floating input-gap">
                <input
                  {...register("empDob", { required: true })}
                  type="date"
                  id="date-of-birth"
                  className={
                    errors.empDob
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                  max={moment().subtract(18, "years").format("YYYY-MM-DD")}
                  min={moment().subtract(80, "years").format("YYYY-MM-DD")}
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empDob}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empDob && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {strings.empDateOfBirthValidation}
                      </span>
                    )}
                  </small>
                </div>
              </div>

              <div className="form-floating input-gap">
                <input
                  {...register("empNat", {
                    required: strings.empNationalityValidation,
                    minLength: {
                      value: 2,
                      message: strings.minChar,
                    },
                    maxLength: {
                      value: 30,
                      message: strings.empNationalityMax
                    },
                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceSecond,
                      message: strings.alphabetsOnly,
                    },
                  })}
                  type="text"
                  className={
                    errors.empNat
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empNat}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empNat && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empNat.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <input
                  {...register("empFather", {
                    required: strings.employeeFatherNameValidation,
                    minLength: {
                      value: 2,
                      message: strings.minCharError,
                    },
                    maxLength:
                    {
                      value: 50,
                      message: strings.fatherNameMax
                    },

                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceSecond,
                      message: strings.errorValid
                    },
                  })}
                  type="text"
                  className={
                    errors.empFather
                      ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                      : "form-control validateEmail email-input pb-0 add-employee-input-text"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.empFather}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.empFather && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {errors.empFather.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>

              <div className="form-floating input-gap">
                <div className="mt-1 mb-1 text-light">
                  <label className="mt-1 select-box-label">
                    {strings.maritalStatus}
                  </label>
                  <select
                    {...register("maritalStatus", { required: true })}
                    className={
                      errors.maritalStatus
                        ? "bg-transparent error"
                        : "bg-transparent select-dropdown small-arrow"
                    }
                  >
                    <option value="" id="dropdown-label" hidden defaultValue={strings.selectMaritalStatus}>
                      {strings.selectMaritalStatus}
                    </option>
                    {strings.mariStatus.map((item, index) => {
                      return (
                        <option id="dropdown-label" value={item} key={index}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                  <div className={"form-validation"}>
                    <small>
                      {errors.maritalStatus && (
                        <span>
                          <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                          {strings.maritalStatusValidation}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
              <div className="form-floating input-gap">
                <div className="mt-1 mb-1 text-light">
                  <label className="mt-1 select-box-label">
                    {strings.employmentType}
                  </label>
                  <select
                    {...register("employmentType", { required: true })}
                    className={
                      errors.employmentType
                        ? "bg-transparent error"
                        : "bg-transparent select-dropdown small-arrow"
                    }
                  >
                    <option value="" id="dropdown-label" hidden defaultValue={strings.selectEmploymentType}>
                      {strings.selectEmploymentType}
                    </option>
                    {strings.employmentTypes.map((item, index) => {
                      return (
                        <option id="dropdown-label" key={index} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                  <div className={"form-validation"}>
                    <small>
                      {errors.employmentType && (
                        <span>
                          <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                          {strings.employmentValidation}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>

              <div className="form-floating input-gap">
                <div className="mt-1 mb-1 text-light">
                  <label className="mt-1 select-box-label">
                    {strings.empGender}
                  </label>
                  <select
                    {...register("empGender", { required: true })}
                    className={
                      errors.empGender
                        ? "bg-transparent error"
                        : "bg-transparent select-dropdown small-arrow"
                    }
                  >
                    <option
                      id="dropdown-label"
                      value=""
                      hidden defaultValue={strings.selectGender}
                    >

                      {strings.selectGender}
                    </option>
                    {strings.empGenderList.map((item, index) => {
                      return (
                        <option id="dropdown-label" key={index} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                  <div className={"form-validation"}>
                    <small>
                      {errors.empGender && (
                        <span>
                          <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong> {strings.genderErrorMsg}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
              <div className="form-floating input-gap">
                <div className="mt-1 mb-1 text-light">
                  <label className="mt-1 select-box-label">
                    {strings.physicallyChallenged}
                  </label>
                  <select
                    {...register("physicallyChallenged", { required: true })}
                    className={
                      errors.physicallyChallenged
                        ? "bg-transparent error"
                        : "bg-transparent select-dropdown small-arrow"
                    }
                  >
                    <option
                      id="dropdown-label"
                      value=""
                      hidden defaultValue={strings.selectOne}
                    >
                      {strings.selectOne}
                    </option>
                    {strings.physicallyChallengedOption.map((item, index) => {
                      return (
                        <option id="dropdown-label" key={index} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                  <div className={"form-validation"}>
                    <small>
                      {errors.physicallyChallenged && (
                        <span>
                          <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                          {strings.physicallyChallengedValidation}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
              <div className="mt-1 mb-1 text-light">
                <label className="mt-1 select-box-label">
                  {strings.bloodGroup}
                </label>
                <select
                  {...register("bloodGroup", { required: true })}
                  className={
                    errors.bloodGroup
                      ? "bg-transparent error"
                      : "bg-transparent select-dropdown small-arrow"
                  }
                >
                  <option
                    id="dropdown-label"
                    value=""
                    hidden defaultValue={strings.selectBlood}
                  >
                    {strings.selectBlood}
                  </option>
                  {strings.bloodGroupOption.map((item, index) => {
                    return (
                      <option id="dropdown-label" key={index} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
                <div className={"form-validation"}>
                  <small>
                    {errors.bloodGroup && (
                      <span>
                        <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                        {strings.bloodGroupValidation}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating input-gap">
                <div className="mt-1 mb-1 text-light">
                  <label className="mt-1 select-box-label">
                    {strings.internationalEmployee}
                  </label>
                  <select
                    {...register("internationalEmployee", { required: true })}
                    className={
                      errors.internationalEmployee
                        ? "bg-transparent error"
                        : "bg-transparent select-dropdown small-arrow"
                    }
                  >
                    <option
                      id="dropdown-label"
                      value=""
                      hidden defaultValue={strings.selectOne}
                    >
                      {strings.selectOne}
                    </option>
                    {strings.internationalEmployeeOption.map((item, index) => {
                      return (
                        <option id="dropdown-label" key={index} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                  <div className={"form-validation"}>
                    <small>
                      {errors.internationalEmployee && (
                        <span>
                          <strong className="me-1">{constants.validationInfoIcon.errorCodeCharacter}</strong>
                          {strings.internationalEmployeeValidation}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
              <div className="form-floating input-gap">

              </div>
              <div className="">

                <button type="submit" className="add-employee-btn">
                  {addingEmployee ? <SpinnerButtonMedium /> : strings.loginBtn}
                  <Ripple duration={1000} />
                </button>

              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}

AddEmployeeModal.propTypes = {
  employeeStatusApi: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired
}